/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { SettingManagementViewSettingResponse } from './SettingManagementViewSettingResponse';

export type SettingManagementViewSettingResponseApiRespoonse = {
    data?: SettingManagementViewSettingResponse;
    status?: SettingManagementViewSettingResponseApiRespoonse.status;
    message?: string;
    errors?: Record<string, Array<string>>;
};

export namespace SettingManagementViewSettingResponseApiRespoonse {

    export enum status {
        SUCCESS = 'success',
        ERROR = 'error',
    }


}

